import { createDraftSafeSelector, createSlice } from '@reduxjs/toolkit'
import { getClients, addClient, removeClient, editClient } from './thunks'
import { formatClients } from '../../util/util'


const initialState = {
  clients: [],
  error: null,
  status: 'idle',
  lastFetched: null,
}

export const clientSlice = createSlice({
  name: 'clients',
  initialState,
  reducers: {
    resetClientStatus: (state) => { state.status = 'idle'; state.lastFetched = null; },
  },
  extraReducers: (builder) => {

    builder.addCase(getClients.pending, (state, action) => {
      state.status = 'loading'
    })

    builder.addCase(getClients.fulfilled, (state, action) => {
      state.clients = action.payload || []
      state.status = 'successful'
      state.lastFetched = Date.now()
    })

    builder.addCase(getClients.rejected, (state, action) => {
      state.status = 'failed'
      state.error = action.error
    })

    builder.addCase(addClient.fulfilled, (state, action) => {
      state.clients.push(action.payload)
    })

    builder.addCase(removeClient.fulfilled, (state, action) => {
      state.clients = state.clients.filter(e => e.id !== action.payload)
    })

    builder.addCase(editClient.fulfilled, (state, action) => {
      const payload = action.payload
      state.clients = state.clients.map(e => e.id === payload.id ? payload : e)
    })


  }
})

export const clientsFormattedSelector = (state) => formatClients(state.client.clients)

export const clientOptionsSelector = createDraftSafeSelector(
  clientsFormattedSelector,
  (state) => state.map(element => ({label:element.name,value:element.id})),
)

export const { resetClientStatus } = clientSlice.actions;

export default clientSlice.reducer